import { Typography } from "@mui/material";
import { Spacing } from "Infrastructure/Themes/Themes";
import type { ReactNode } from "react";
import { Flex } from "../Core/Flex";
import { HStack } from "../Core/Stack";

type Props = {
  icon: ReactNode;
  text: string | undefined | null;
};

export const InfoItem = ({ icon, text }: Props) => {
  if (!text) return null;
  return (
    <HStack spacing={Spacing.M} alignItems="center">
      <Flex color="text.secondary" alignItems="center" sx={{ "& svg": { fontSize: 14 } }}>
        {icon}
      </Flex>
      <Typography variant="caption" color="text.secondary">
        {text}
      </Typography>
    </HStack>
  );
};
